import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {distinctUntilChanged, filter, Observable, Subject, takeUntil, withLatestFrom} from "rxjs";
import {ProcessFilterType, ProcessI} from "../../../infrastructure/interfaces/process.interface";
import {selectSelectedProcess} from "../../../infrastructure/store/process/process.selector";
import {
  selectDetailsProcessResult,
  selectLoadingDetailProcessResult,
  selectLoadingProcessResultMap,
  selectLoadingProcessResultPermissions,
  selectProcessResultFilter,
  selectProcessResultGlobalSearch,
  selectProcessResultMap,
  selectProcessResultPaginator,
  selectResultDetailsTab, selectSearchParameters, selectSelectedProcessResults,
  selectShowFilterBar,
  selectShowRightBar,
  selectViewComponentProcessResult
} from "../../../infrastructure/store/process-result/process-result.selector";
import {
  ProcessResultFilterI,
  ProcessResultI,
  ProcessResultPaginatorI, SearchParameters,
  ViewComponentType
} from "../../../infrastructure/interfaces/process-result.interface";
import {DetailTabs, TaskPermissionsObjectI,} from "../../../infrastructure/interfaces/task.interface";
import {Router} from "@angular/router";
import {
  loadProcessResultGridData, loadProcessResultKanban,
  loadProcessResults,
  removeProcessResultPermissions,
  setDetailProcessResult, setLoadingProcessResultGridData,
  setLoadingResult, setParameterBookmarkedFilters,
  setParameterDynamicFilters,
  setParameterEntries,
  setParameterPage, setParameterProcessStatusFilters, setParameterProcessTasksFilters,
  setResultDetailsTab,
  setShowFilterBar,
  setShowRightBar,
  setViewComponentProcessResult,
  updateProcessResultPermissions,
  updateProcessResultPermissionsSuccess
} from "../../../infrastructure/store/process-result/process-result.actions";
import {
  initialProcessResultPaginator,
  initialProcessStatusFilter,
  itemsPerPageList
} from "../../../infrastructure/store/process-result/state";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {LocalStorageService} from "../../../infrastructure/services/local-storage.service";
import {selectPermissionsObjects} from "../../../infrastructure/store/permissions/permissions.selector";
import {PermissionsObjectI} from "../../../infrastructure/interfaces/permissions.interface";
import {loadMapProcesslList} from '../../../infrastructure/store/map/map.action';
import {selectActiveViews, selectDefaultView} from "../../../infrastructure/store/config/config.selector";
import {TranslateService} from "@mangosoft/mango-layout";
import {AccessControlService} from "../../../infrastructure/services/access-control.service";


@Component({
  selector: 'app-status-board',
  templateUrl: './status-board.component.html',
  styleUrls: ['./status-board.component.scss']
})
export class StatusBoardComponent implements OnInit, OnDestroy{

  destroy$ = new Subject<void>();

  math = Math;

  viewComponentType = ViewComponentType;

  detailTabs = DetailTabs;

  processFilterType = ProcessFilterType;

  showFilterBar: boolean = false;
  showRightBar: boolean = false;

  viewComponent: ViewComponentType | null = null;

  // todo: fix in interfaces
  itemPerPageList = itemsPerPageList;

  selectedProcess: ProcessI | null = null;

  resultPaginator: ProcessResultPaginatorI = initialProcessResultPaginator

  filterForm!: FormGroup;

  dynamicFilterForm!: FormGroup;
  dynamicFilterFormActive: any;

  processResultFilter: ProcessResultFilterI = initialProcessStatusFilter;
  globalSearch: string = '';

  processResultStatusFilterSelectAll = new Subject<boolean>();
  processResultStatusFilterClearAll = new Subject<boolean>();
  processStatusFilterCollapse = true;

  processResultTaskFilterSelectAll = new Subject<boolean>();
  processResultTaskFilterClearAll = new Subject<boolean>();
  processStateFilterCollapse = true;

  permissionObjects: Observable<PermissionsObjectI[]>;
  selectedTab: DetailTabs = DetailTabs.security;
  detailsProcessResult: ProcessResultI | null = null;
  detailsProcessResultPermissions: TaskPermissionsObjectI[] = [];
  loadingProcessResultPermissions: boolean = false;
  loadingDetailProcessResult: boolean = false;

  processResultMapLoaded: number = 0;
  processResultMapTotal: number = 0;
  processResultMapValid: number = 0;
  loadingProcessResultMap: boolean = false;

  ui_active_views: ViewComponentType[] = [];

  language!: any;

  selectedProcessResults: ProcessResultI[] = [];

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private translateService: TranslateService,
    private accessControlService: AccessControlService,
  ) {
    this.translateService
      .init("process-manager")
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.language = data
      });

    this.permissionObjects = this.store.select(selectPermissionsObjects);
  }

  ngOnInit() {
    this.store.dispatch(loadMapProcesslList());

    // Listen for selected process changes
    this.store.select(selectSelectedProcess).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectSearchParameters)),
    ).subscribe(([value, searchParameters]) => {
      if (value) {
        this.selectedProcess = value;
        this.buildFilterForm(value);
      }
    })

    this.store.select(selectSearchParameters).pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((a,b) => JSON.stringify(a) === JSON.stringify(b)),
      withLatestFrom(this.store.select(selectSelectedProcess)),
      filter(([searchParameters, process]) => !!process)
    ).subscribe(([searchParameters, process]) => {
      if (process){

        if (this.dynamicFilterForm){
          let values: any = {
            bookmarked: searchParameters.bookmarked_filter,
            process_status: searchParameters.process_status_filter.split(","),
            tasks: searchParameters.process_tasks_filter.split(",")
          }

          // Generate dynamic fields from process model
          process.process_filters.forEach((filter) => {
            if (filter.field){
              values[filter.field] = (searchParameters?.dynamic_filter || {})?.[filter.field]
            }
          })

          this.dynamicFilterForm.patchValue(values)
        }else{
          this.buildDynamicFilterForm(process, searchParameters);
        }

        // Calc if exist active filters
        this.dynamicFilterFormActive = Object.keys(this.dynamicFilterForm.value).reduce((acc: boolean, key) => {
          switch (key){
            case 'bookmarked':
              if (key == 'bookmarked' && this.dynamicFilterForm.get(key)?.value === 'active') acc = acc || true;
              break;
            case 'process_status':
              if ((this.dynamicFilterForm.get(key)?.value || []).join(",")) acc = acc || true;
              break;
            case 'tasks':
              if ((this.dynamicFilterForm.get(key)?.value || []).join(",")) acc = acc || true;
              break;
            default:
              if ((this.dynamicFilterForm.get(key)?.value || "").length) acc = acc || true;
              break;
          }

          return acc
        }, false);

      }
    })

    // Listen for result paginator changes
    this.store.select(selectProcessResultPaginator).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.resultPaginator = value;
    })

    // Listen for Details Task changes
    this.store.select(selectDetailsProcessResult).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.detailsProcessResult = value;
      this.detailsProcessResultPermissions = [];
      if (this.detailsProcessResult){
        this.detailsProcessResultPermissions = this.detailsProcessResult.acl.objects.map((value) => {
          return {
            object: {
              ...value
            },
            permissions: {
              list: (this.detailsProcessResult?.acl.list || []).filter((val) => value.username === val).length > 0,
              read: (this.detailsProcessResult?.acl.read || []).filter((val) => value.username === val).length > 0,
              write: (this.detailsProcessResult?.acl.write || []).filter((val) => value.username === val).length > 0,
              delete: (this.detailsProcessResult?.acl.delete || []).filter((val) => value.username === val).length > 0,
            }
          }
        })
      }
    })

    // Listen for loading process result permissions
    this.store.select(selectLoadingProcessResultPermissions).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingProcessResultPermissions = value;
    })

    // Listen for show filter bar changes
    this.store.select(selectShowFilterBar).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.showFilterBar = value
    })

    // Listen for show right bar changes
    this.store.select(selectShowRightBar).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.showRightBar = value
    })

    // Listen for detail tab changes
    this.store.select(selectResultDetailsTab).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.selectedTab = value
    })

    // Listen for view component changes
    this.store.select(selectViewComponentProcessResult).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      if (value){
        this.viewComponent = value
      }
    })

    //listen for global search changes
    this.store.select(selectProcessResultGlobalSearch).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.globalSearch = value || '';
    })

    //listen for global search changes
    this.store.select(selectLoadingDetailProcessResult).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingDetailProcessResult = value;
    })

    // listen for loading process result map changes
    this.store.select(selectLoadingProcessResultMap).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingProcessResultMap = value
    })

    // listen for process result map changes
    this.store.select(selectProcessResultMap).pipe(
      takeUntil(this.destroy$)
    ).subscribe((processResultMap) => {
      this.processResultMapTotal = processResultMap.count;
      this.processResultMapLoaded = processResultMap.loaded;
      this.processResultMapValid = processResultMap.valid
    })

    //Listen for default view
    this.store.select(selectDefaultView).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectViewComponentProcessResult))
    ).subscribe(([defaultViewComponent, currentViewComponent]) => {
      if (!currentViewComponent){
        this.store.dispatch(setViewComponentProcessResult({value: defaultViewComponent}))
      }
      // this.viewComponent = defaultViewComponent;
    })

    // listen for active views config changes
    this.store.select(selectActiveViews).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.ui_active_views = value;
    })

    //listen for selected process resultssss
    this.store.select(selectSelectedProcessResults).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.selectedProcessResults = value
    })
  }

  buildFilterForm(process: ProcessI) {
    this.filterForm = this.fb.group({
      itemPerPage: this.localStorageService.getItemPerPage() || this.itemPerPageList[0].value
    })

    this.itemPerPage?.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.itemPerPage?.patchValue(value, {onlySelf: true, emitEvent: false});
      this.localStorageService.setItemPerPage(value);

      this.store.dispatch(setParameterEntries({value: value}));
      if (this.selectedProcess){
        this.store.dispatch(setLoadingResult({status: true}));
        this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}))
      }

    })

  }

  buildDefaultFilter(processModel: ProcessI){
    let defaultFilter: any = {};

    // Initialize dynamic default values
    processModel.process_filters.forEach((filter) => {
      let default_value = filter.default || null;
      if (filter.type === ProcessFilterType.date && default_value === 'today'){
        default_value = new Date().toISOString().split("T")[0]
      }
      defaultFilter[filter.field] = default_value
    })

    // Update with fixed filters
    defaultFilter = {
      ...defaultFilter,
      process_status: processModel.process_states.states_list
        .filter((k) => k.selected)
        .map((k) => k.key),
      tasks: processModel.tasks
        .filter((v)=>v?.selected || false)
        .map((v)=>v.id)
    }

    return defaultFilter;
  }


  buildDynamicFilterForm(process: ProcessI, searchParams:SearchParameters) {
    const group: any = {
      bookmarked: new FormControl(searchParams.bookmarked_filter),
      process_status: new FormControl(searchParams.process_status_filter.split(",")),
      tasks: new FormControl(searchParams.process_tasks_filter.split(","))
    }

    // Generate dynamic fields from process model
    process.process_filters.forEach((filter) => {
      group[filter.field] = new FormControl((searchParams?.dynamic_filter || {})?.[filter.field])
    })
    this.dynamicFilterForm = new FormGroup(group);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  paginate(action: "next"|"last"|"first"|"previous"){
    if (this.selectedProcess) {
      switch (action){

        case "first":
          if (this.resultPaginator.previous){
            this.store.dispatch(setLoadingResult({status: true}));
            this.store.dispatch(setParameterPage({value: "1"}));
            this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}));
          }
          break;

        case "previous":
          if (this.resultPaginator.previous) {
            this.store.dispatch(setLoadingResult({status: true}));
            this.store.dispatch(setParameterPage({value: this.resultPaginator.previous}));
            this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}));
          }
          break;

        case "next":
          if (this.resultPaginator.next) {
            this.store.dispatch(setLoadingResult({status: true}));
            this.store.dispatch(setParameterPage({value: this.resultPaginator.next}));
            this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}));
          }
          break;

        case "last":
          if (this.resultPaginator.next){
            const lastPage = Math.floor(+this.resultPaginator.count/+this.itemPerPage?.value || +itemsPerPageList[0].value) + (this.resultPaginator.count % this.itemPerPage?.value > 0 ? 1 : 0)

            this.store.dispatch(setParameterPage({value: lastPage}));

            this.store.dispatch(setLoadingResult({status: true}));
            this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}));
          }
          break;
      }
    }
  }

  //Filter apply
  applyFilter(values: any) {

    if (this.selectedProcess){

      this.store.dispatch(setParameterProcessStatusFilters({value: (values?.process_status || []).join(",")}));
      this.store.dispatch(setParameterProcessTasksFilters({value: (values.tasks || []).join(",")}));
      this.store.dispatch(setParameterBookmarkedFilters({value: values?.bookmarked}));

      const {bookmarked:_, process_status:__, tasks:___,...filter} = values
      this.store.dispatch(setParameterDynamicFilters({value: filter}));

      // Load table data
      this.store.dispatch(setLoadingResult({status: true}));
      this.store.dispatch(loadProcessResults({processId: this.selectedProcess.id}))

      // Load grid data
      this.store.dispatch(setLoadingProcessResultGridData({status: true}));
      this.store.dispatch(loadProcessResultGridData({
        processId: this.selectedProcess.id
      }))

    }
  }




  toggleFilterMenu(){
    if (!this.showFilterBar){
      this.store.dispatch(setShowRightBar({status: false}));
    }
    this.store.dispatch(setShowFilterBar({status: !this.showFilterBar}));
  }

  toggleLeftBar() {
    this.store.dispatch(setShowFilterBar({status: !this.showFilterBar}))
  }
  toggleRightBar() {
    if (!this.showRightBar){
      this.store.dispatch(setShowFilterBar({status: false}));
    }
    this.store.dispatch(setShowRightBar({status: !this.showRightBar}))
  }

  setDetailsTab(tab: DetailTabs) {
    this.store.dispatch(setResultDetailsTab({tab: tab}));
  }



  addObjectPermission(value: TaskPermissionsObjectI) {
    if (this.detailsProcessResult){
      let acl = {...this.detailsProcessResult.acl};

      acl.objects = (this.detailsProcessResult?.acl?.objects || []).filter((val) => val.username !== value.object.username);
      acl.list = (this.detailsProcessResult?.acl?.list || []).filter((val) => val !== value.object.username);
      acl.read = (this.detailsProcessResult?.acl?.read || []).filter((val) => val !== value.object.username);
      acl.write = (this.detailsProcessResult?.acl?.write || []).filter((val) => val !== value.object.username);
      acl.delete = (this.detailsProcessResult?.acl?.delete || []).filter((val) => val !== value.object.username);

      acl.objects.push(value.object);
      if (value.permissions.list){ acl.list.push(value.object.username)}
      if (value.permissions.read){ acl.read.push(value.object.username)}
      if (value.permissions.write){ acl.write.push(value.object.username)}
      if (value.permissions.delete){ acl.delete.push(value.object.username)}

      this.store.dispatch(updateProcessResultPermissionsSuccess({
        result: {
          ...this.detailsProcessResult,
          acl: acl
        }
      }))

      this.store.dispatch(updateProcessResultPermissions({
        processId: this.detailsProcessResult.processId,
        resultId: this.detailsProcessResult.id,
        data: value
      }))
    }
  }

  removeObjectPermission(value: TaskPermissionsObjectI) {
    if (this.detailsProcessResult){
      let acl = {...this.detailsProcessResult.acl};

      acl.objects = (this.detailsProcessResult?.acl?.objects || []).filter((val) => val.username !== value.object.username);
      acl.list = (this.detailsProcessResult?.acl?.list || []).filter((val) => val !== value.object.username);
      acl.read = (this.detailsProcessResult?.acl?.read || []).filter((val) => val !== value.object.username);
      acl.write = (this.detailsProcessResult?.acl?.write || []).filter((val) => val !== value.object.username);
      acl.delete = (this.detailsProcessResult?.acl?.delete || []).filter((val) => val !== value.object.username);

      this.store.dispatch(updateProcessResultPermissionsSuccess({
        result: {
          ...this.detailsProcessResult,
          acl: acl
        }
      }))

      this.store.dispatch(removeProcessResultPermissions({
        resultId: this.detailsProcessResult.id,
        processId: this.detailsProcessResult.processId,
        data: value
      }))
    }

  }

  changeViewComponent(type: ViewComponentType) {
    this.store.dispatch(setShowRightBar({status: false}));
    this.store.dispatch(setShowFilterBar({status: false}));
    this.store.dispatch(setDetailProcessResult({result: null}));
    this.store.dispatch(setViewComponentProcessResult({value: type}))
  }


  detailProcessResultWritePermissions(result: ProcessResultI | null): boolean {
    if (result) {
      const isProcessWritableByUserGroup = (this.accessControlService.getAuthUserData()?.scope || "").split(",").some((group: string) => (result?.acl?.write || []).includes(group));
      const isProcessWritableByUser = (result?.acl?.write || []).includes(this.accessControlService.getAuthUserData().username)
      return isProcessWritableByUser || isProcessWritableByUserGroup;
    }
    return false;
  }


  get itemPerPage() {
    return this.filterForm ? this.filterForm.get("itemPerPage") : null
  }

  get bookmarked() {
    return this.dynamicFilterForm ? this.dynamicFilterForm.get("bookmarked") : null
  }

  get process_status() {
    return this.dynamicFilterForm ? this.dynamicFilterForm.get("process_status") : null
  }

  get tasks() {
    return this.dynamicFilterForm ?  this.dynamicFilterForm.get("tasks") : null
  }

  change_all_process_status(value: boolean){
    value ? this.processResultStatusFilterSelectAll.next(value) : this.processResultStatusFilterClearAll.next(value);
  }

  change_all_process_tasks(value: boolean){
    value ? this.processResultTaskFilterSelectAll.next(value) : this.processResultTaskFilterClearAll.next(value);
  }



}
